<div class="flex h-full flex-col items-center justify-center bg-surface">
  <div class="flex size-full max-w-125 flex-col items-center gap-2xl px-md py-2xl">
    <sb-logo class="w-40 shrink-0" variant="wordmark" />

    <div class="flex min-h-0 w-full grow flex-col items-center justify-center gap-lg">
      <h1 class="reset-h shrink-0 text-center text-4xl font-bold text-default">
        {{ 'Your trial has ended' | translate }}
      </h1>

      @if (isLoading) {
        <sb-loading-state class="shrink-0" />
      } @else if (currentPlanName && mode) {
        <div class="flex min-h-0 w-full flex-col gap-md rounded-xl bg-surface-page p-xl shadow-xs">
          <span class="shrink-0 text-3xl font-bold text-default">{{ currentPlanName }}</span>
          @if (currentPlanTagline) {
            <span class="shrink-0 text-base">{{ currentPlanTagline | translate }}</span>
          }

          <ul class="reset-ul flex min-h-0 flex-col gap-sm overflow-y-auto">
            @for (feature of currentPlanFeatures; track feature) {
              <li class="flex items-center gap-sm text-base text-default">
                <sb-icon class="shrink-0 text-brand" name="check" />
                {{ feature | translate: currentPlanFeatureParams }}
              </li>
            }
          </ul>

          @if (mode === 'manager') {
            <button
              sb-button
              color="primary"
              class="w-full shrink-0"
              type="button"
              (click)="confirmPlan()"
              [disabled]="isProcessingFree"
            >
              {{ 'Continue with [planName]' | translate: { planName: currentPlanName } }}
            </button>
          }
        </div>

        @if (mode === 'manager') {
          <button
            class="reset-button shrink-0 cursor-pointer text-base font-medium text-brand hover:underline disabled:cursor-default disabled:opacity-50"
            type="button"
            [disabled]="isProcessingFree"
            (click)="continueWithFree()"
          >
            {{ 'Continue with Free instead' | translate }}
          </button>

          <span class="flex shrink-0 items-center gap-xs text-sm text-subtle">
            <sb-icon class="shrink-0 text-success" name="check-circle-regular" />
            {{ 'All payments are handled securely via Chargebee.' | translate }}
          </span>
        } @else {
          <p class="reset-p shrink-0 text-center text-default">
            {{
              'Let your manager know if you want to continue with [planName] and keep reducing admin time for you and your team.'
                | translate: { planName: currentPlanName }
            }}
          </p>
        }
      } @else if (mode) {
        <p class="reset-p shrink-0 text-center text-default">
          {{ "We couldn't load your plan details. You can switch to Free or head back to login below." | translate }}
        </p>
        @if (mode === 'manager' && hasFreeOption) {
          <button
            class="reset-button shrink-0 cursor-pointer text-base font-medium text-brand hover:underline disabled:cursor-default disabled:opacity-50"
            type="button"
            [disabled]="isProcessingFree"
            (click)="continueWithFree()"
          >
            {{ 'Continue with Free instead' | translate }}
          </button>
        }
      }
    </div>

    <button
      class="reset-button shrink-0 cursor-pointer text-sm font-medium text-subtle hover:underline"
      type="button"
      (click)="backToLogin()"
    >
      {{ 'Back to login' | translate }}
    </button>
  </div>
</div>
